import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import eomAnyZerosService from "../services/eom-any-zeroes-service";
import { Modal } from "react-responsive-modal";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
const tablePropsInit = {
  columns: [
    { key: "payor", title: "Payor" },
    { key: "group", title: "Group" },
    { key: "unique", title: "Charge code" },
    { key: "rxf_number", title: "RXF Number " },
    { key: "seq_num", title: "Sequence Number " },
    { key: "qty", title: "Quantity" },
    { key: "price_code", title: "Price Code" },
    { key: "type11", title: "Type", style: { display: "none" } },
    { key: "disease_state", title: "Disease state" },
    { key: "type", title: "Type" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const AnyZeros = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const deleteAnyZeros = async (id) => {
    try {
      await eomAnyZerosService.deleteData(id);
      let resp = await eomAnyZerosService.getAnyZerosData(year, month);
      dispatch(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error deleting price. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    }
  };

  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3 cursor-pointer">
          <Link to={`edit-anyZeros/${rowData.id}`}>
            <img src="/img/edit_icon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
        <span className="inline-block mx-4 cursor-pointer">
          <img
            src="./img/delete.svg"
            className="m-auto w-4 h-4"
            alt="delete"
            title="Delete"
            onClick={() => {
              setSelectedId(rowData?.id);
              setDeleteOpen(true);
            }}
          />
        </span>
      </div>
    );
  };

  const [selectedId, setSelectedId] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const onDeleteCloseModal = () => {
    setDeleteOpen(false);
    setSelectedId("");
  };

  const [month, setMonth] = useState();
  const [year, setYear] = useState("2021");
  const totalMonthsList = () => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.map((i, index) => (
      <option value={index + 1} key={i}>
        {i}
      </option>
    ));
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = [];
      if (month && year)
        resp = await eomAnyZerosService.getAnyZerosData(year, month);
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };

  const handleDownload = async (event) => {
    try {
      const { hide } = cogoToast.info(
        "Downloading is in progress. Please wait for sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await eomAnyZerosService.downloadDocument(year, month);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error downloading document. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const getResults = async () => {
    try {
      let resp = [];
      if (month && year) {
        setLoading(true);
        resp = await eomAnyZerosService.getAnyZerosData(year, month);
        setLoading(false);
      } else {
        const { hide } = cogoToast.error("Please select month and year", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
      }

      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting results. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <Modal open={deleteOpen} onClose={onDeleteCloseModal} center>
        <div className="pt-10 px-8 pb-4 ">
          <h3
            className="text-lg leading-6 font-medium text-gray-900 text-center"
            id="modal-headline"
          >
            Are you sure you want to delete?
          </h3>
          <div className="flex justify-center">
            <button
              onClick={() => {
                deleteAnyZeros(selectedId);
                setDeleteOpen(false);
              }}
              type="button"
              className="mr-4 rounded font-medium h-10 text-white w-auto px-6 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Yes
            </button>
            <button
              onClick={() => {
                setDeleteOpen(false);
              }}
              type="button"
              className="rounded font-medium h-10 text-white w-auto px-4 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
            >
              Cancel
            </button>
          </div>
          {/*
           */}
        </div>
      </Modal>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/3 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">ANY ZEROS</span>
          </div>
          <div className="w-full sm:w-2/3 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 mb-2 right-5 top-1 bottom-3"
              ></img>
            </span>

            <span className="mr-3">
              <Link
                to="/eomFiles"
                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                GO TO EOM FILES
              </Link>
            </span>
          </div>
        </div>

        <div className="p-2 text-xs usersList gridList overflow-x-auto  ">
          <select
            name="list_month"
            aria-label="Select Month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/5"
          >
            <option value="0">Select Month</option>
            {totalMonthsList()}
          </select>
          <span className="ml-4">
            <select
              name="list_year"
              aria-label="Select Year"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/5 "
            >
              <option value="">Select year</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
            </select>
          </span>
          <span className="ml-4">
            <button
              disabled={loading}
              onClick={() => {
                getResults();
              }}
              className={
                loading
                  ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                  : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
              }
            >
              SUBMIT
            </button>
            <span className="ml-4">
              <button
                type="submit"
                disabled={!month}
                className={
                  loading || !month
                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                    : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                }
                aria-label="DOWNLOAD"
                onClick={() => handleDownload()}
              >
                DOWNLOAD
              </button>
            </span>
          </span>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(AnyZeros)
);
